import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Phpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csdowhile(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  const right = {
    padding: '0 0 0 '+padding+'rem',
  };
return(
      <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free PHP Do While Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Php do While tutorial for beginners CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,php boucle do while,do while en php,php do while loop,do while loop in php,do while in php,Php do While,Php do while for,php do while loop example,end for loop Php,Php exit for loop,Php foreach do While" />
 <link rel="canonical" href="https://www.codeexampler.com/php-do-while" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Do-while Loop Statement in Php</h1>
    <div className="first">
        <a href="/php-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">In do-while, Php loop will consistently execute at least once
</p>


<h2 className="headings">Do-while Php loop Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>
            {"\n"}<span className="qwerty-2"> Do</span>
              <span className="qwerty-3">  &#123;</span>
              {"\n"} 
              <span className="qwerty-4"> statement</span>
              <span className="qwerty-3">;</span>
              {"\n"} 
              <span className="qwerty-3"> &#125;</span>
              {"\n"} 
              <span className="qwerty-6">While</span>
              <span className="qwerty-3"> (</span>
              <span className="qwerty-5">condition</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
              {"\n"} 
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>  





<h2 className="headings">Q-Write a program for loop in Do while loop and print names Example in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>   {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-7">1</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-2">do</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-2">echo </span>
            <span className="qwerty-10">"</span>
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Code </span>
            <span className="qwerty-4">Exampler </span>
            
            <span className="qwerty-3">\</span>
            <span className="qwerty-3">n</span>
            <span className="qwerty-10">";</span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">++</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-3">while </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">&#60;</span>
            <span className="qwerty-6">= </span>
            <span className="qwerty-7">10</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code> {"\n"}
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Code </span>
            <span className="qwerty-4">Exampler</span>
            {"\n"}
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Code </span>
            <span className="qwerty-4">Exampler</span>
            {"\n"}
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Code </span>
            <span className="qwerty-4">Exampler</span>
            {"\n"}
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Code </span>
            <span className="qwerty-4">Exampler</span>
            {"\n"}
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Code </span>
            <span className="qwerty-4">Exampler</span>
            {"\n"}
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Code </span>
            <span className="qwerty-4">Exampler</span>
            {"\n"}
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Code </span>
            <span className="qwerty-4">Exampler</span>
            {"\n"}
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Code </span>
            <span className="qwerty-4">Exampler</span>
            {"\n"}
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Code </span>
            <span className="qwerty-4">Exampler</span>
            {"\n"}
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Code </span>
            <span className="qwerty-4">Exampler</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>




<h2 className="headings">Q-Write a program Addition or increment of 2 numbers every Times in do-while loop Example in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-7">1</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-2">do</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-2">echo </span>
            <span className="qwerty-10">"</span>
            <span className="qwerty-6">Hello </span>
            <span className="qwerty-5">Everyone</span>
            <span className="qwerty-10">".</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-10">."</span>
           
            <span className="qwerty-4">\</span>
            <span className="qwerty-3">n</span>
            <span className="qwerty-10">";</span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">+ </span>
            <span className="qwerty-7">2</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-3">while </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">&#60;</span>
            <span className="qwerty-6">= </span>
            <span className="qwerty-7">5</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code> {"\n"}
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Everyone </span>
            <span className="qwerty-7">1</span>
            {"\n"}
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Everyone </span>
            <span className="qwerty-7">3</span>
            {"\n"}
            <span className="qwerty-6">Hello</span>
            <span className="qwerty-5"> Everyone </span>
            <span className="qwerty-7">5</span>
            {"\n"}
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">Increment in Do while Php loop Example:</h2>



<h2 className="headings">Q-Write a program Addition or increment of 1+ every Times in do-while loop Example in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-7">1</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-2">do</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-2">echo </span>
            <span className="qwerty-10">"</span>
            <span className="qwerty-6">Increment </span>
            <span className="qwerty-5">No</span>
            <span className="qwerty-10">".</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-10">."</span>
            
            <span className="qwerty-3">\</span>
            <span className="qwerty-3">n</span>
            <span className="qwerty-10">";</span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">++</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-3">while </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">&#60;</span>
            <span className="qwerty-6">= </span>
            <span className="qwerty-7">10</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code> {"\n"}
            <span className="qwerty-6">Increment</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">1</span>
            {"\n"}
            <span className="qwerty-6">Increment</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">2</span>
            {"\n"}
            <span className="qwerty-6">Increment</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">3</span>
            {"\n"}
            <span className="qwerty-6">Increment</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">4</span>
            {"\n"}
            <span className="qwerty-6">Increment</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">5</span>
            {"\n"}
            <span className="qwerty-6">Increment</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">6</span>
            {"\n"}
            <span className="qwerty-6">Increment</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">7</span>
            {"\n"}
            <span className="qwerty-6">Increment</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">8</span>
            {"\n"}
            <span className="qwerty-6">Increment</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">9</span>
            {"\n"}
            <span className="qwerty-6">Increment</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">10</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">Decrement in Do while Loop Php Example:</h2>



<h2 className="headings">Q-Write a program Subtract or decrement of -1 numbers every Times in do-while loop Example in Php?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-2">?</span>
            <span className="qwerty-4">php </span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">= </span>
            <span className="qwerty-7">10</span>
            <span className="qwerty-2">; </span>
            {"\n"}
            <span className="qwerty-2">do</span>
            {"\n"}
            <span className="qwerty-4">&#123; </span>
            {"\n"}
            <span className="qwerty-2">echo </span>
            <span className="qwerty-10">"</span>
            <span className="qwerty-6">Decrement  </span>
            <span className="qwerty-5">No</span>
            <span className="qwerty-10">".</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a</span>
            <span className="qwerty-10">."</span>
            
            <span className="qwerty-4">\</span>
            <span className="qwerty-3">n</span>
            <span className="qwerty-10">";</span>
            {"\n"}
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">--</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-4">&#125;</span>
            {"\n"}
            <span className="qwerty-3">while </span>
            <span className="qwerty-5">(</span>
            <span className="qwerty-3">$</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-2">&#62;</span>
            <span className="qwerty-6">= </span>
            <span className="qwerty-7">1</span>
            <span className="qwerty-3">)</span>
            <span className="qwerty-3">;</span>
            {"\n"}
            <span className="qwerty-2">?</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <h2 className="headings">Output-</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code> {"\n"}
            <span className="qwerty-6">Decrement</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">10</span>
            {"\n"}
            <span className="qwerty-6">Decrement</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">9</span>
            {"\n"}
            <span className="qwerty-6">Decrement</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">8</span>
            {"\n"}
            <span className="qwerty-6">Decrement</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">7</span>
            {"\n"}
            <span className="qwerty-6">Decrement</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">6</span>
            {"\n"}
            <span className="qwerty-6">Decrement</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">5</span>
            {"\n"}
            <span className="qwerty-6">Decrement</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">4</span>
            {"\n"}
            <span className="qwerty-6">Decrement</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">3</span>
            {"\n"}
            <span className="qwerty-6">Decrement</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">2</span>
            {"\n"}
            <span className="qwerty-6">Decrement</span>
            <span className="qwerty-5"> No </span>
            <span className="qwerty-4">1</span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/php-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/php-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csdowhile;